import React, { useState, useEffect } from "react";
import DataTable from "../components/DataTable";
import SnackbarAlert from "../components/SnackbarAlert";
import { Box, TextField, Tooltip, Typography, Button, CircularProgress, Dialog, DialogTitle, DialogContent, DialogActions, Switch } from "@mui/material";
import { webEndPoint } from '../constants/globalConstants';
import { makeRequest } from "../services/api";
export default function User() {
    const [datasource, setDatasource] = useState([]);
    const [search, setSearch] = useState("");
    const [snackbar, setSnackbar] = useState(false);
    const [message, setMessage] = useState("");
    const [loading, setLoading] = useState(false);
    const [openDialog, setOpenDialog] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);
    useEffect(() => {
        fetchUserData();
    }, []);
    const fetchUserData = async () => {
        setLoading(true);
        try {
            let url = webEndPoint + "user";
            const response = await makeRequest("get", url);
            if (response) {
                setDatasource(response?.data);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };
    const filteredState = datasource?.filter((d) =>
        d?.first_name?.toLowerCase().includes(search?.toLowerCase()) || d?.mobile_number?.toLowerCase().includes(search?.toLowerCase())
    );
    const handleView = (user) => {
        setSelectedUser(user);
        setOpenDialog(true);
    };
    const handleToggleStatus = async (item) => {
        const newStatus = item?.isActive === 0 ? 1 : 0;
        try {
            setLoading(true);
            let url = webEndPoint + "user/status/" + item.rfId;
            const payload = {
                isActive: newStatus
            };
            const response = await makeRequest("patch", url, payload);
            if (response) {
                setMessage(
                    newStatus === 0 ? "User Enabled Successfully" : "User Disabled Successfully"
                );
                setSnackbar(true);
                fetchUserData();
            }
        } catch (err) {
            console.error(err);
            setMessage("Failed to update status");
            setSnackbar(true);
        } finally {
            setLoading(false);
        }
    };
    const columns = ["S.No", "User Name", "Mobile Number", "Active Status","Action"];
    const rows = filteredState?.map((user, index) => [index + 1, user.first_name, user.mobile_number, 
    <Switch checked={user?.isActive === 0} onChange={() => handleToggleStatus(user)} color="success" />,
    <Box>
        <Tooltip title="View User Details">
            <Button variant="contained" color="primary" onClick={() => handleView(user)}>View</Button>
        </Tooltip>
    </Box>
    ]);
    return (
        <Box sx={{ position: "relative" }}>
            {loading && (
                <Box sx={{ position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh", backgroundColor: "rgba(255,255,255,0.6)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 9999, }}>
                    <CircularProgress />
                </Box>
            )}
            <Typography variant="h6" sx={{ mb: 3, fontWeight: 500 }}>User List</Typography>
            <Box sx={{ display: "flex", flexDirection: { xs: "column", sm: "row" }, gap: 2, alignItems: { xs: "stretch", sm: "center" }, justifyContent: "space-between", mb: 2, width: "100%", }}>
                <TextField label="Search User " size="small" value={search} onChange={(e) => setSearch(e.target.value)} sx={{ width: { xs: "100%", sm: "70%", md: 600 } }} />
            </Box>
            <DataTable columns={columns} rows={rows} />
            <SnackbarAlert open={snackbar} setOpen={setSnackbar} message={message} />
            <Dialog open={openDialog} onClose={() => setOpenDialog(false)} fullWidth maxWidth="sm">
                <DialogTitle>User Details</DialogTitle>
                <DialogContent>
                    {selectedUser && (
                        <Box sx={{ display: "grid", gridTemplateColumns: "1fr 2fr", rowGap: 2 }}>
                            <Typography fontWeight="bold">First Name</Typography>
                            <Typography>{selectedUser.first_name || "-"}</Typography>
                            <Typography fontWeight="bold">Last Name</Typography>
                            <Typography>{selectedUser.last_name || "-"}</Typography>
                            <Typography fontWeight="bold">Mobile</Typography>
                            <Typography>{selectedUser.mobile_number || "-"}</Typography>
                            <Typography fontWeight="bold">Email</Typography>
                            <Typography>{selectedUser.email_id || "-"}</Typography>
                            <Typography fontWeight="bold">City</Typography>
                            <Typography>{selectedUser.city || "-"}</Typography>
                            <Typography fontWeight="bold">State</Typography>
                            <Typography>{selectedUser.state_name || "-"}</Typography>
                            <Typography fontWeight="bold">Pincode</Typography>
                            <Typography>{selectedUser.pincode || "-"}</Typography>
                            <Typography fontWeight="bold">Address</Typography>
                            <Typography>
                                {[selectedUser.address_line1, selectedUser.address_line2]
                                    .filter(Boolean)
                                    .join(", ") || "-"}
                            </Typography>
                        </Box>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenDialog(false)}>Close</Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
}